import * as z from "zod";
import {
  carrierClaimsDimensionSchema,
  carrierClaimsFilterSchema,
  carrierClaimsSnapshotGroupBySchema,
} from "./carrier-claims-analytics-common";

export const carrierClaimsOpenClaimsRowSchema =
  carrierClaimsDimensionSchema.extend({
    unsubmitted: z.number(),
    unsubmittedOver14Days: z.number(),
    unsubmittedUsd: z.number(),
    open: z.number(),
    pendingDocs: z.number(),
    neverChecked: z.number(),
    abandoned: z.number(),
    oldestOpenSubmissionAt: z.string().nullable(),
    open0To30Usd: z.number(),
    open31To60Usd: z.number(),
    open61PlusUsd: z.number(),
  });
export type CarrierClaimsOpenClaimsRow = z.infer<
  typeof carrierClaimsOpenClaimsRowSchema
>;

export const getCarrierClaimsOpenClaims = {
  name: "getCarrierClaimsOpenClaims" as const,
  input: carrierClaimsFilterSchema.extend({
    groupBy: carrierClaimsSnapshotGroupBySchema,
  }),
  output: z.object({ rows: z.array(carrierClaimsOpenClaimsRowSchema) }),
};

export type GetCarrierClaimsOpenClaimsInput = z.infer<
  typeof getCarrierClaimsOpenClaims.input
>;
export type GetCarrierClaimsOpenClaimsOutput = z.infer<
  typeof getCarrierClaimsOpenClaims.output
>;
